var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gt-b2b-order"},[_c('ImportPage',{attrs:{"default-org-disabled":_vm.defaultOrgDisabled,"page-title":"导入","template":_vm.urlTemplate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }